<!-- Had to remove role="Alert" because screen reader was announcing message twice -->
<div>
  <div class="content-container">
    <span class="content-span">{{ data.message }}</span>
  </div>
  <div class="button-container">
    <button class="primary-button" id="primaryBtn" [mat-dialog-close]="true" tabindex="0">
      {{ data.okLabel }}
    </button>
    <button class="secondary-button" [mat-dialog-close]="false" tabindex="0">
      {{ data.cancelLabel }}
    </button>
  </div>
</div>
